// extracted by mini-css-extract-plugin
module.exports = {"resources":"CompanyResources_resources__4Ebtu","showMoreBtn":"CompanyResources_showMoreBtn__Ewb9L"};